import { Koi } from '@ksyos/koi';
import type { ServiceOrganizationProvider } from '@common/interfaces/serviceOrganizationProvider';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';

export type TypedServiceOrganizationProviderSchema = TypedSchema<ServiceOrganizationProvider>;

export function getServiceOrganizationProviderSchema(isDraft?: boolean) {
    const requiredIdSchema = Koi.string().uuid();

    return Koi.object({
        organizationId: isDraft ? requiredIdSchema.allow(null) : requiredIdSchema,
        practitionerId: requiredIdSchema.allow(null),
    });
}
